import { Link as TanstackLink } from "@tanstack/react-router"
import type { UiLinkProps, UiImageProps } from "@aix/ui/src/router"
import { forwardRef } from "react"

export const Link = forwardRef<HTMLAnchorElement, UiLinkProps>(function Link({ href, ...rest }, ref) {
  // TanstackLink uses 'to' prop instead of 'href'
  return <TanstackLink ref={ref} to={href} {...rest} />
})

export const Image = ({ alt, ...props }: UiImageProps) => <img alt={alt ?? ""} {...props} />
